import React, { useState, useEffect } from 'react' 
import { useNavigate, Link } from 'react-router-dom';

import axios from "axios";
import * as Yup from "yup";
import { useFormik} from "formik";
import swal from "sweetalert";

export default function UserAdd() {

const nav = useNavigate();
const [nameError , setNameError] = useState('')
const [emailError , setEmailError] = useState('')
const [passwordError , setPassword] = useState('')
const [phoneNumberError , setPhoneNumber] = useState('')
const phoneRegExp = /^((\\[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required.")
    .min(4, "Name must be at least 4 characters.")
    .max(50, "Name can not be exceed 50 characters."),
    email: Yup.string().required("Email is required.").email("Email is invalid."),
    password: Yup.string()
    .required("Password is required.")
    .min(6, "Password must be at least 6 characters.")
    .max(40, "Password can be not exceed 40 characters."),
    phone_number: Yup.string().required("Phone number is required.")
    .min(8, "Phone number must be at least 8 digits.")
    .max(15, "Phone number can not be exceed 15 digits.")
    .matches(phoneRegExp, 'Phone number is not valid.'),
  });
  const config = {
    headers: { 
      "Content-type": "Application/json",
      "Authorization": localStorage.getItem("token")
    }
  }; 
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      phone_number: "",
      status: "Active",
      role_type: "Admin",
    },
    validationSchema,
    onSubmit: async (data, {setErrors}) => { 
      console.log('>>>>>>', data)      
      await axios
        .post(process.env.REACT_APP_API_KEY + "api/admin/user-add", data, {
          headers: {
          "Content-type": "Application/json",
          "Authorization": localStorage.getItem("token")
          }   
      })
        .then((res) => {
          //Check for Authorized
          if(res.data.code == 403){
            localStorage.clear();
            nav('/admin/login');
          }

          if (res.status === 200) {
            swal({
              title: "Wow!",
              text: "Account created successfully!",
              icon: "success",
              button: "Okay",
            });
            console.log(res.data);
            nav("/admin/users-list");
            
          } 
        }).catch(error => {
          
            if (!error.response.data.status) {
              const resdata = error.response.data.errors;
              console.log(resdata);
              Object.keys(resdata).forEach(function(key) {
                if(key == 'name'){
                  setNameError(resdata[key]);
                }
                if(key == 'email'){
                  setEmailError(resdata[key]);
                }
                if(key == 'password'){
                  setPassword(resdata[key]);
                }
                if(key == 'phone_number'){
                  setPhoneNumber(resdata[key]);
                }
                console.log('Key : ' + key + ', Value : ' + resdata[key])
              })
            } else {
              swal("Oops", "Unauthorized User", "error");
            }
          console.log('aya',error.response.data);
      });
     // console.log(JSON.stringify(data, null, 2));

    },
  });

  return (
          <div className="wrapper">
          
          <div className="content-wrapper">

      <form  className="mx-5 col-md-5" onSubmit={formik.handleSubmit}>
        <h2>Add New User</h2>
        
        <div className="ui form box-body">
          <div className="field form-group">               
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              autoComplete="nope"
              placeholder="Full Name"             
              className="form-control"
              onChange={formik.handleChange}
              value={formik.values.name}   
            />
            <div className="text-danger">
            {formik.errors.name || nameError ? formik.errors.name || nameError : null}
            </div>
          </div>
          
          <div className="field form-group">               
            <label>Email Address</label>
           
            <input
              type="text"
              name="email"
              autoComplete="nope"
              placeholder="Email Address"     
              onChange={formik.handleChange}
              value={formik.values.email}          
              className="field form-control"
            />
            <div className="text-danger">
            {formik.errors.email || emailError ? formik.errors.email || emailError : null}
            </div>
          </div>
          
          <div className="field form-group">               
            <label>Password</label>
            <input
              type="password"
              name="password"
              autoComplete="nope"
              placeholder="Password"
              onChange={formik.handleChange}
              value={formik.values.password}                  
              className="field form-control"
            />
            <div className="text-danger">
            {formik.errors.password || passwordError ? formik.errors.password || passwordError : null}
            </div>
          </div>

          <div className="field form-group">               
            <label>Phone number</label>
            <input
              type="text"
              name="phone_number"
              autoComplete="nope"
              placeholder="Phone number"              
              className="field form-control"
              onChange={formik.handleChange}
              value={formik.values.phone_number}
            />
              <div className="text-danger">
                {formik.errors.phone_number || phoneNumberError ? formik.errors.phone_number || phoneNumberError : null}
              </div>
          </div>
          <div className="field form-group">               
            <label>User Role</label>
            <select className='form-control' name='role_type' onChange={formik.handleChange} value={formik.values.role_type}>
              <option value="Admin">Admin</option>
              <option value="SubAdmin">Sub Admin</option>
            </select>
          </div>
          <div className="field form-group">               
            <label>Status</label>
            <select className='form-control' name="status" onChange={formik.handleChange} value={formik.values.status}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              
            </select>
          </div>
          <div className='btn-allign'>
          <button type="submit" className="btn btn-danger submit-btn">Register</button>
          <Link to="/admin/users-list"><button className="btn btn-primary submit-btn">Back</button></Link>
          </div>
        </div>
      </form>
    </div>
          
          </div>
  )
}